import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Wrapper, Paragraph} from '../Modal/modal.style';
import {Button} from '../../styles/components/button.style';

export class IosPrivateModeModal extends PureComponent {
  render() {
    const {closeModalCallback} = this.props;

    return (
      <Wrapper>
        <Paragraph>
          <FormattedMessage id="modal.iosPrivateMode" />
        </Paragraph>
        <Button onClick={closeModalCallback}><FormattedMessage id="modal.ok" /></Button>
      </Wrapper>
    );
  }
}

IosPrivateModeModal.propTypes = {
  closeModalCallback: PropTypes.func
};

export default IosPrivateModeModal;



// WEBPACK FOOTER //
// ./components/ModalContent/IosPrivateModeModal.js